import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "state/rootReducer";
import { ICON_STROKE, LikeIcon, PlaylistIcon, SearchIcon } from "shared/icons";

export interface OwnProps {
  url: string;
}

interface StateProps {
  isLoggedIn: boolean;
}

export type NavTabsProps = OwnProps & StateProps;

/**
 * Primary navigation. Replaces the old split between a 156px sidebar (labels)
 * and a separate mobile-only icon bar — one component now serves both, showing
 * labels where there is room and icons where there is not.
 */
const TABS: {
  to: string;
  label: string;
  Icon: typeof SearchIcon;
  requiresLogin: boolean;
}[] = [
  { to: "/songs", label: "Discover", Icon: SearchIcon, requiresLogin: false },
  { to: "/play", label: "Listen", Icon: PlaylistIcon, requiresLogin: true },
  { to: "/likes", label: "Feedback", Icon: LikeIcon, requiresLogin: true },
];

export function NavTabs(props: NavTabsProps): JSX.Element {
  return (
    <nav className="flex flex-row items-center gap-1" aria-label="Primary">
      {TABS.filter((tab) => !tab.requiresLogin || props.isLoggedIn).map(
        ({ to, label, Icon }) => {
          const isActive = props.url.includes(to);

          return (
            <Link
              key={to}
              to={to}
              aria-current={isActive ? "page" : undefined}
              className={`flex items-center gap-2 px-2.5 sm:px-3 py-2 text-sm whitespace-nowrap ${
                isActive ? "active-tab" : "inactive-tab"
              }`}
            >
              <Icon size={17} strokeWidth={ICON_STROKE} aria-hidden="true" />
              <span className="hidden sm:inline">{label}</span>
            </Link>
          );
        }
      )}
    </nav>
  );
}

function mapState(state: RootState): StateProps {
  return {
    isLoggedIn: state.user.currentUser?.id !== undefined,
  };
}

export default connect(mapState)(NavTabs);
